import { useAssistanceViewContext } from './AssistanceViewContext';
import classnames from '../../../core/utils/classnames.tsx';
import * as React from 'react';
import { useTranslation } from 'react-i18next';

const AssistanceSectionEmptyState = ({ title, description, className, children, ...props }: any) => {
    const { t } = useTranslation('assistance');

    const { isFastTrackEnabled, onFastTrackChange } = useAssistanceViewContext();

    return (
        <div
            className={classnames(
                'flex flex-col items-center justify-center p-10 gap-4 bg-surface-strong text-sm rounded-lg w-full',
                className
            )}
            {...props}
        >
            <div className="flex flex-col items-center gap-1 text-center">
                <span className="text-content-medium font-bold">{t(title)}</span>
                {description && <span className="text-content-medium">{t(description)}</span>}
                {children}
            </div>
            {isFastTrackEnabled && (
                <button
                    className="text-content-brand-default hover:text-content-brand-hover cursor-pointer font-medium"
                    onClick={() => onFastTrackChange(false)}
                >
                    {t('fastTrack.emptyState.button')}
                </button>
            )}
        </div>
    );
};

export default AssistanceSectionEmptyState;
